var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightningBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 83.578125 127.828125 L 59.296875 209.652344 C 59.117188 210.253906 59.632813 210.832031 60.25 210.726563 L 83.984375 206.648438 C 84.433594 206.570313 84.863281 206.863281 84.957031 207.304688 L 95.132813 255.476563 C 95.335938 256.4375 96.738281 256.335938 96.804688 255.355469 L 101.265625 187.550781 C 101.304688 187.011719 100.828125 186.578125 100.292969 186.660156 L 78.804688 190.011719 C 78.253906 190.097656 77.769531 189.628906 77.835938 189.074219 L 85.226563 128.171875 C 85.351563 127.144531 83.871094 126.835938 83.578125 127.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 206.886719 36.039063 L 97.019531 148.917969 C 96.492188 149.460938 96.875 150.367188 97.628906 150.367188 L 159.675781 150.367188 C 160.308594 150.367188 160.71875 151.03125 160.441406 151.597656 L 105.554688 262.984375 C 105.121094 263.867188 106.273438 264.660156 106.945313 263.949219 L 235.496094 127.242188 C 235.992188 126.71875 235.652344 125.855469 234.933594 125.804688 L 167.453125 121.28125 C 166.84375 121.242188 166.472656 120.59375 166.746094 120.050781 L 208.261719 37.019531 C 208.695313 36.144531 207.566406 35.34375 206.886719 36.039063 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 239.511719 177.949219 L 173.679688 209.207031 C 173.105469 209.480469 173.019531 210.269531 173.527344 210.65625 L 187.816406 221.578125 C 188.285156 221.9375 188.257813 222.652344 187.761719 222.972656 L 127.257813 262.253906 C 126.378906 262.824219 127.105469 264.171875 128.0625 263.753906 L 220.9375 223.355469 C 221.558594 223.089844 221.632813 222.234375 221.066406 221.859375 L 204.699219 211.054688 C 204.222656 210.742188 204.179688 210.058594 204.617188 209.691406 L 240.429688 179.371094 C 241.191406 178.726563 240.414063 177.519531 239.511719 177.949219 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBolt);
export default __webpack_public_path__ + "static/media/LightningBolt.69f6846133b87be9e950ce409bd913c6.svg";
export { ForwardRef as ReactComponent };